import type {
  AgentCheckParams,
  AgentCreateEmailOTPInput,
  AgentCreateOTPInput,
  AgentLoginByEmailInput,
  AgentLoginByPhoneInput,
  AgentRefreshTokenInput,
  AgentRegisterByEmailInput,
  AgentRegisterByPhoneInput,
  AgentResendOTPInput,
  AgentResendOTPOutput,
  AgentSetProfileInput,
  AgentSetProfileOutput,
  AgentSetUserEmailInput,
  AgentSetUserPhoneInput,
  AgentSetUsernameInput,
  RequestParams,
  UserCheckUserOutput,
} from '../api'
import { api, ContentType } from '../api'

const agentLoginByEmail = async (data: AgentLoginByEmailInput) => {
  return await api.v1.agentLoginByEmail(data)
}

const agentLoginByPhone = async (data: AgentLoginByPhoneInput) => {
  return await api.v1.agentLoginByPhone(data)
}

const agentRegisterByEmail = async (data: AgentRegisterByEmailInput) => {
  return await api.v1.agentRegisterByEmail(data)
}

const agentRegisterByPhone = async (data: AgentRegisterByPhoneInput) => {
  return await api.v1.agentRegisterByPhone(data)
}

const agentDetails = async () => {
  return await api.v1.agentAuthVerify({})
}

const agentRefresh = async (data: AgentRefreshTokenInput) => {
  return await api.v1.agentAuthRefresh(data)
}

const agentSetUserEmail = async (data: AgentSetUserEmailInput) => {
  return await api.v1.agentSetUserEmail(data)
}

const agentSetUserPhone = async (data: AgentSetUserPhoneInput) => {
  return await api.v1.agentSetUserPhone(data)
}

const agentCreateEmailOtp = async (data: AgentCreateEmailOTPInput) => {
  return await api.v1.agentCreateEmailOtp({
    ...data,
  })
}
const agentCreatePhoneOtp = async (data: AgentCreateOTPInput) => {
  return await api.v1.agentCreatePhoneOtp({
    ...data,
  })
}

const agentResendOtp = async (
  data: AgentResendOTPInput,
): Promise<AgentResendOTPOutput> => {
  return api.v1.agentResendOtp(data).then((res) => res.data)
}

const agentCheck = async (
  data: AgentCheckParams,
): Promise<UserCheckUserOutput> => {
  return api.v1.agentCheck(data).then((res) => res.data)
}

const agentSetProfile = async (
  data: AgentSetProfileInput,
): Promise<AgentSetProfileOutput> => {
  return api.v1.agentSetProfile(data).then((res) => res.data)
}

const agentUploadProfilePicture = async (formData: FormData) => {
  return await api.v1.agentUploadProfilePicture({
    body: formData,
    type: ContentType.FormData,
  } as RequestParams)
}

const agentUploadCoverPicture = async (formData: FormData) => {
  return await api.v1.agentUploadCoverPicture({
    body: formData,
    type: ContentType.FormData,
  } as RequestParams)
}

// agentSetUsername
const agentSetUsername = async (data: AgentSetUsernameInput) => {
  return await api.v1.agentSetUsername(data)
}

export default {
  agentLoginByEmail,
  agentLoginByPhone,
  agentRegisterByEmail,
  agentRegisterByPhone,
  agentDetails,
  agentRefresh,
  agentSetUserEmail,
  agentSetUserPhone,
  agentCreateEmailOtp,
  agentCreatePhoneOtp,
  agentResendOtp,
  agentCheck,
  agentSetProfile,
  agentUploadProfilePicture,
  agentUploadCoverPicture,
  agentSetUsername,
}
